import { StyledContent } from '@/components/styles'
import { ArrowButton, RoutedLink } from '@/components'
import { useTranslation } from "react-i18next";

const TitleContentLink = ({ data }) => {
  const { content: htmlContent, link } = data
  const { t } = useTranslation("global");

  return (
    <>
      {htmlContent && (
        <StyledContent.Description>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </StyledContent.Description>
      )}

      <RoutedLink to={link} component={StyledContent.Link}>
      {t('wiki.more')}
        <ArrowButton />
      </RoutedLink>
    </>
  )
}

export default TitleContentLink
